module.exports = __webpack_public_path__ + "static/inspectionImage-49d0f8205bd9a1bb3b1eea5796b7d0e0.jpg";